<script setup lang="ts">
import { computed, useId } from 'vue'
import { Label } from '@/components/ui/label'

/**
 * Champ de formulaire accessible : libellé lié, message d'erreur annoncé, et le slot
 * reçoit `id`, `invalid` et `describedBy` à poser sur le contrôle. `anchor` pose un
 * identifiant stable sur le bloc, cible des liens « compléter mon profil » (SP-24).
 */
const props = defineProps<{ label: string; error?: string; hint?: string; anchor?: string }>()

const id = useId()
const errorId = `${id}-error`
const hintId = `${id}-hint`
const invalid = computed(() => !!props.error)
const describedBy = computed(
  () => [props.error ? errorId : null, props.hint ? hintId : null].filter(Boolean).join(' ') || undefined,
)
</script>

<template>
  <div :id="anchor" class="grid gap-1.5" :class="anchor ? 'scroll-mt-28' : ''">
    <Label :for="id">{{ label }}</Label>
    <slot :id="id" :invalid="invalid" :described-by="describedBy" />
    <p v-if="hint && !error" :id="hintId" class="text-xs text-muted-foreground">{{ hint }}</p>
    <p v-if="error" :id="errorId" role="alert" class="text-xs text-destructive">{{ error }}</p>
  </div>
</template>
